import { render } from "./ModalSV.vue?vue&type=template&id=f96485a2&scoped=true"
import script from "./ModalSV.vue?vue&type=script&lang=js"
export * from "./ModalSV.vue?vue&type=script&lang=js"

import "./ModalSV.vue?vue&type=style&index=0&id=f96485a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96485a2"]])

export default __exports__